import KyeFieldDecrypt from './component.js'
export default KyeFieldDecrypt



// WEBPACK FOOTER //
// ./src/public/components/kye-field-decrypt/index.js